<template>
    <div>       
        <b-card>
            <template v-if="preEmision">
                <div slot="header">
                    <b-row align-v="center">
                        <b-col cols="2">
                            <b-row class="text-center">
                                <b-col>
                                    <datepicker v-model="femision" :format="customFormatter" :language="es" :bootstrap-styling="true" :disabledDates="diasnopermitidos" :placeholder="currentdate"></datepicker>
                                </b-col>                          
                            </b-row>
                        </b-col>
                        <b-col cols="2"></b-col>
                        <b-col cols="3">
                            <template>
                                <h3 class="display-">Factura Exportación Hospedaje</h3> 
                            </template>
                        </b-col>
                        <b-col cols="3"></b-col>
                        <b-col cols="2">
                            <b-row align-v="center">
                                <b-col cols="4" class="text-right">
                                    <label>Moneda</label>
                                </b-col>
                                <b-col cols="8">
                                    <select class="custom-select mr-sm-2" v-model="tipodemoneda">
                                            <option :value="moneda" v-for="moneda in tipoMoneda" v-bind:key="moneda.id">
                                                {{ moneda.descripcion }}
                                            </option>
                                    </select>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>                
                </div>
                <b-row>
                    <b-col sm="2">
                        <select class="custom-select mr-sm-2 input-placedark input-dark" id="inlineFormCustomSelect" v-model="tipoDocumentoExtrangeros">                       
                            <option :value="tipodocumento.tipo" v-for="tipodocumento in documentosIdentidadExtrangeros" v-bind:key="tipodocumento.tipo">
                                {{ tipodocumento.nombre }}
                            </option>
                        </select> 
                    </b-col>
                    <b-col sm="2">
                        <b-input-group>
                            <b-form-input class="input-placedark input-dark" placeholder="Buscar Documento (*)" v-model="invoice.receptor.nro" @change="getReceivers(1)"></b-form-input>
                        </b-input-group>
                        <template v-if="cargandoreceptor">
                                <b-list-group-item>Buscando <i class="fa fa-spin fa-spinner"></i></b-list-group-item> 
                        </template>
                        <b-list-group v-if="listarec" class="searcher-field">
                            <b-list-group-item v-if="norec">No hay Receptores con ese número</b-list-group-item>                                 
                            <template v-for="(item, index) in listaReceptores">
                                <b-list-group-item :key="index" @click="setReceiver(item)" class="searcher-result">{{item.idReceptor + ' - ' + item.razonSocial}}</b-list-group-item>
                            </template> 
                        </b-list-group>  
                    </b-col>
                    <b-col sm="3">
                        <b-input-group>
                            <b-input v-model="invoice.receptor.razonSocial" :value="invoice.receptor.razonSocial" @change="getReceivers(2)" placeholder="Razon social (*)"></b-input>
                            <b-input-group-text slot="append">
                                <button class="btn btn-warning btn-sm sinresultados" @click="closeReceiver()"><i class="fa fa-times"></i></button>
                            </b-input-group-text>
                        </b-input-group>
                    </b-col>
                    <b-col sm="3">
                        <b-col sm="12"><b-form-input class="input-placedark input-dark" size="md" type="text" v-model="invoice.receptor.direccionFiscal" :value="invoice.receptor.direccionFiscal" placeholder="Dirección (*)"></b-form-input></b-col>    
                    </b-col>
                    <b-col col sm="2">
                        <b-row>
                            <template v-if="typeInvoice == 1">
                                <b-col>
                                    <b-input-group>
                                        <template v-if="seriesCargadas">
                                            <b-button size="md" variant="secondary" outline-success>
                                                Cargando Series... <i class="fa fa-spin fa-spinner"></i>
                                            </b-button>
                                        </template>
                                        <template v-else>
                                            <select class="form-control input-placedark input-dark" v-model="indexSerie">
                                                <option v-for="(serie, index) in listaSeries" :value="index" :key="index">{{ serie }}</option>
                                            </select>
                                        </template>
                                    </b-input-group>
                                </b-col>
                            </template>
                            <template v-else>
                                <b-col>
                                    <input v-model="seriecon" maxlength="4" type="text" class="form-control  input-requerido input-dark" placeholder="Serie (*)">
                                </b-col>
                                <b-col>
                                    <input v-model="numero" minlength="1" type="text" class="form-control" placeholder="Numero">
                                </b-col>
                            </template>
                        </b-row>
                    </b-col>
                </b-row>
                <hr>        
                <div class="row">     
                    <div class="col-sm-1 form-group">
                        <input type="text" class="form-control input-placedark" maxlength="250" v-model="cantidad" placeholder="Cantidad (*)">
                    </div>        
                    <div class="col-sm-2 form-group">
                        <input min="0.0" step="0.01" v-model="precioVentaUnitario" class="form-control input-placedark" placeholder="Precio Unitario (*)" required>
                        <small v-if="checkprecioventaunitario" class="form-text text-muted"><span class="text-danger">{{ responsecheckprecioventaunitario }}</span></small> 
                    </div>
                    <div class="col-sm-9 form-group">
                        <input type="text" class="form-control input-placedark" maxlength="250" v-model="descripcion" placeholder="Descripción (*)">
                    </div>
                </div>
                <!-- Items Factura Hospedaje -->
                <b-row>
                    <b-col cols="12">
                        <b-row>
                            <b-col cols="1">
                                <select class="custom-select" id="inlineFormCustomSelect" v-model="tipoDocumentoHuesped" :disabled="disableditemsadicionales">                       
                                    <option :value="tipodocumento.tipo" v-for="tipodocumento in documentosIdentidad" v-bind:key="tipodocumento.tipo">
                                        {{ tipodocumento.nombre }}
                                    </option>
                                </select> 
                            </b-col>
                            <b-col cols="2">
                                <b-input-group>
                                    <b-form-input class="input-placedark input-dark" placeholder="Ingresar Documento" v-model="numeroDocumentoHuesped" :disabled="disableditemsadicionales"></b-form-input>   
                                </b-input-group> 
                            </b-col>
                            <b-col cols="3">
                                <b-form-input size="md" type="text" v-model="nombresApellidosHuesped" placeholder="Nombre de Huesped" :disabled="disableditemsadicionales"></b-form-input>
                            </b-col>
                            <b-col cols="3">
                                <b-form-select v-model="pasaporte" class="mb-3">
                                    <template v-slot:first>
                                        <option :value="null" disabled>Pais Emisor de Pasaporte</option>
                                    </template>
                                    <option v-for="pasaporte in listaPaises" :value="pasaporte" :key="pasaporte.codigo">{{ pasaporte.nombre }}</option>
                                </b-form-select>
                            </b-col>
                            <b-col cols="3">
                                <b-form-select v-model="residencia" class="mb-3">
                                    <template v-slot:first>
                                        <option :value="null" disabled>Pais de Residencia</option>
                                    </template>
                                    <option v-for="residencia in listaPaises" :value="residencia" :key="residencia.codigo">{{ residencia.nombre }}</option>
                                </b-form-select>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="2">
                                <datepicker class="fechamachasa" v-model="fechaIngresoPais" :format="customFormatter" :language="es" :bootstrap-styling="true" :placeholder="placeholderIngresoPais" :disabled="disableditemsadicionales"></datepicker>
                            </b-col>
                            <b-col cols="2">
                                <datepicker v-model="fechaIngresoEstablecimiento" :format="customFormatter" :language="es" :bootstrap-styling="true" :placeholder="placeholderIngresoEstablecimiento" :disabled="disableditemsadicionales"></datepicker>
                            </b-col>
                            <b-col cols="2">
                                <datepicker v-model="fechaSalidaEstablecimiento" :format="customFormatter" :language="es" :bootstrap-styling="true" :placeholder="placeholderSalidaEstablecimiento" :disabled="disableditemsadicionales"></datepicker>
                            </b-col>
                            <b-col cols="2">
                                <datepicker v-model="fechaConsumo" :format="customFormatter" :language="es" :bootstrap-styling="true" :placeholder="placeholderFechaConsumo" :disabled="disableditemsadicionales"></datepicker>
                            </b-col>
                            <b-col cols="2">
                                <input v-model="numeroDiasPermanencia" maxlength="4" type="number" class="form-control" placeholder="Dias de Permanencia" :disabled="disableditemsadicionales">
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row><br>
                <!--Fin de Items Boleto-->
                <div class="row text-center">
                    <div class="col-md-12">
                        <b-button :variant="addedit ? 'primary':'warning'" :disabled="validateFields()" @click="addItem"><i :class="addedit ? 'fa fa-plus':'fa fa-edit'"></i> {{ textbutton }}</b-button>
                    </div> 
                </div>
                <br>
                <b-row>
                    <b-col xl="12">
                        <b-table hover :items="items" :fields="fields">
                            <template slot="[acciones]" slot-scope="row">
                                <b-button variant="ligth" size="sm" v-b-tooltip.hover title="Mostrar detalles" @click="row.toggleDetails"><i class="fa fa-plus"></i></b-button>
                                <b-button variant="ligth" size="sm" class="ml-2" v-b-tooltip.hover title="Editar item" @click="editItem(row.item, row.index)"><i class="fa fa-edit text-primary"></i></b-button>
                                <b-button variant="ligth" size="sm" class="ml-2" v-b-tooltip.hover title="Eliminar item" @click.prevent="deleteItem(index)"><i class="fa fa-trash text-danger"></i></b-button>
                            </template>
                            <template slot="row-details" slot-scope="row">
                                <b-card>
                                    <b-table striped hover :items="[row.item.adicional.beneficioHospedaje]" :fields="fields_details">
                                    </b-table>
                                </b-card>
                            </template>
                        </b-table>
                    </b-col>
                </b-row>
                <hr>
            <div class="row">
                <div class="col-md-8">
                    <div>
                        <b-btn block v-b-toggle.extras class="m-1 colorestelemovil">Extras</b-btn>
                        <b-collapse id="extras">
                            <b-card>
                                <div class="row">
                                    <div class="col-sm-3 form-group">
                                        <select class="custom-select mr-sm-2" v-model="formadepago">
                                            <option :value="fpago.codigo" v-for="fpago in formaPago" v-bind:key="fpago.codigo">
                                                {{ fpago.nombre }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-sm-3 form-group">
                                        <b-form-group
                                            label-for="input_seriedeguia"
                                            :invalid-feedback="invalidFeedbackOrdenCompra"
                                            :valid-feedback="validFeedbackOrdenCompra"
                                            :state="stateOrdenCompra">
                                            <b-input-group size="md">
                                                <b-form-input :value="ordenCompra" 
                                                    required 
                                                    @input="ordenCompra = $event.toUpperCase()" 
                                                    v-model="ordenCompra" 
                                                    maxlength="20" 
                                                    class="form-control" 
                                                    type="text" 
                                                    id="input_ordendecompra" 
                                                    :state="stateOrdenCompra" 
                                                    placeholder="Orden de Compra">
                                                </b-form-input>
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-sm-3 form group">
                                        <datepicker v-model="fvencimiento" :language="es" :format="customFormatter" :bootstrap-styling="true" placeholder="Fecha de Vencimiento"></datepicker>
                                    </div>
                                </div>
                            </b-card>
                        </b-collapse>
                    </div>
                    <div>
                        <b-btn block v-b-toggle.relacionadas class="m-1 colorestelemovil">Guias Relacionadas</b-btn>
                        <b-collapse id="relacionadas">
                            <b-card>
                                <div class="row">
                                    <div class="col-sm-2 form-group">
                                        <b-form-group
                                            label-for="input_seriedeguia"
                                            :invalid-feedback="invalidFeedbackSerieGuia"
                                            :valid-feedback="validFeedbackSerieGuia"
                                            :state="stateSerieGuia">
                                            <b-input-group size="md">
                                                <b-form-input :value="seriedeguia" 
                                                    required @input="seriedeguia = $event.toUpperCase()" 
                                                    v-model="seriedeguia" 
                                                    minlength="4" 
                                                    maxlength="4" 
                                                    class="form-control" 
                                                    type="text" 
                                                    id="input_seriedeguia" 
                                                    :state="stateSerieGuia" 
                                                    placeholder="Serie">
                                                </b-form-input>
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-sm-2 form-group">
                                        <input v-model="numerodeguia" type="number" class="form-control" placeholder="Numero" required>  
                                    </div>
                                    <div class="col-sm-6 form-group">
                                        <select class="custom-select mr-sm-2" v-model="tipodeguia" :disabled="tipoguialock">
                                            <option :value="tipo.codigo" v-for="tipo in tiposGuia" v-bind:key="tipo.codigo">
                                                {{ tipo.nombre }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-sm-2">
                                        <button v-if="validateFieldsGuia()" class="btn btn-primary" @click="addGuia"><i class="fa fa-plus"></i> Agregar</button>
                                        <button v-else class="btn btn-secondary" disabled><i class="fa fa-plus"></i> Agregar</button>
                                    </div>
                                </div>
                                <div class="row">
                                    <b-table striped hover :items="items_guias" :fields="fields_guias">
                                        <template striped hover slot="acciones" slot-scope="guiasRelacionadas">
                                            <b-button-group>
                                                <b-button title="Eliminar Guia" @click="deleteGuia(item)"><i class="fa fa-trash"></i></b-button>
                                            </b-button-group>
                                        </template>
                                    </b-table>
                                </div>
                            </b-card>
                        </b-collapse>
                    </div>
                    <div>
                        <b-btn block v-b-toggle.adicionales class="m-1 colorestelemovil">Datos Adicionales</b-btn>
                        <b-collapse id="adicionales">
                            <b-card>
                                <div class="row">
                                    <div class="col-sm-5 form-group">
                                        <input type="text" placeholder="Nombre del Adicional" class="form-control" v-model="clave">
                                    </div>
                                    <div class="col-sm-5 form-group">
                                        <input type="text" placeholder="Valor del Adicional" class="form-control" v-model="valor">
                                    </div>
                                    <div class="col-sm-2">
                                        <button v-if="validateFieldsAdicionales()" class="btn btn-primary" @click="addAdicional"><i class="fa fa-plus"></i> Agregar</button>
                                        <button v-else class="btn btn-secondary" disabled><i class="fa fa-plus"></i> Agregar</button>
                                    </div>
                                </div>
                                <div class="row">
                                    <b-table striped hover :items="items_adicionales" :fields="fields_adicionales">
                                        <template striped hover slot="acciones" slot-scope="items_adicionales">
                                            <b-button-group>
                                                <b-button title="Eliminar Adicional" @click="deleteAdicional(item)"><i class="fa fa-trash"></i></b-button>
                                            </b-button-group>
                                        </template>
                                    </b-table>
                                </div>
                            </b-card>
                        </b-collapse>
                    </div>
                </div>
                <div class="col-md-4">
                    <b-row>
                        <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12" class="text-left">
                        <b-button v-b-modal.otroscargosmodal1 variant="secondary" :disabled="this.items.length > 0 ? false:true"><i class="fa fa-hand-holding-usd"></i> Otros Cargos</b-button>
                            <b-modal id="otroscargosmodal1" title="Agregar Otros Cargos" size="lg" centered v-model="otroscargosmodal" >
                            <template>
                                <b-row>
                                <b-col cols="12" sm="12"	md="6"	lg="6"	xl="6">
                                    <select class="form-control input-placedark input-dark" v-model="otroCargo">
                                    <option v-for="otrocargo in listaOtrosCargos" :value="otrocargo" :key="otrocargo.codigo">{{ otrocargo.descripcion }}</option>
                                    </select>
                                </b-col>
                                <b-col cols="2" sm="2"	md="1"	lg="1"	xl="1"><p class="mt-2">{{ moneda.simbolo }}</p></b-col>
                                <b-col cols="8" sm="8"	md="4"	lg="4"	xl="4">
                                    <b-form-input
                                    type="number"
                                    v-model="montoOtroCargo"
                                    placeholder="Monto del cargo"
                                    @keyup.enter="addMontoCargo()"
                                    ></b-form-input>
                                </b-col>
                                <b-col cols="2" sm="2"	md="1"	lg="1"	xl="1">
                                    <b-button variant="success" @click="addMontoCargo()"><i class="fa fa-plus"></i></b-button>
                                </b-col>
                                </b-row>
                                <b-row>
                                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                                    <b-table  
                                        striped 
                                        hover 
                                        small 
                                        responsive
                                        outlined
                                        :fields="otroscargos_fields" 
                                        :items="listaOtrosCargosAgregados" 
                                        :busy="otroscargosbusy">
                                        <div slot="table-busy" class="text-center text-danger my-2">
                                            <b-spinner class="align-middle"></b-spinner>
                                            <strong> Cargando...</strong>
                                        </div>
                                        <template slot="descripcion" slot-scope="row">
                                            <div v-if="row.item.codigoCargoDescuento==50">
                                                Cargos globales que no afectan la base imponible del IGV/IVAP
                                            </div>
                                        </template>
                                        <template slot="montoCargo" slot-scope="row">
                                            {{ moneda.simbolo }} {{ row.item.montoCargoDescuento }}
                                        </template>
                                        <template slot="acciones" slot-scope="row">
                                            <b-button size="sm" variant="danger" @click="deleteOtroCargo(row.index, row.item)"><i class="fa fa-trash"></i></b-button>
                                        </template>
                                    </b-table>
                                </b-col>
                                </b-row>
                            </template>
                            <div slot="modal-footer" class="w-100">
                                <b-row>
                                <b-col cols="12" sm="12"	md="8"	lg="8"	xl="8">
                                    <b-button size="sm" variant="danger" @click="cerrarmodalOtroCargo()"><i class="fa fa-times"></i> Cerrar</b-button>
                                </b-col>
                                <b-col cols="12" sm="12"	md="4"	lg="4"	xl="4">
                                    Sumatoria de cargos: {{ moneda.simbolo }} {{ accumulateOtrosCargos() }}
                                </b-col>
                                </b-row>
                            </div>
                        </b-modal>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                        <div class="text-center">
                            <strong>TOTALES</strong>
                        </div>
                        </b-col>
                    </b-row><hr>
                    <b-row>
                        <b-col cols="6" sm="6"	md="6"	lg="6"	xl="6">
                        <div><strong>IGV:</strong></div>
                        <div><strong>Venta Gravada:</strong></div>
                        <div><strong>Venta Exonerada:</strong></div>
                        <div><strong>Venta Inafecta:</strong></div>
                        <div><strong>Venta Gratuita:</strong></div>
                        <div><strong>Venta Exportación:</strong></div>
                        <div><strong>Otros Cargos:</strong></div>
                        <div><strong>Venta:</strong></div>
                        <b-row>
                            <b-col cols="12">
                            <template v-if="tipoOperacion == '1001'">
                                <hr>
                                <select class="form-control input-placedark input-dark" v-model="detraccion">
                                <option v-for="detraccion in listaDeDetracciones" :value="detraccion" :key="detraccion.codigo">{{ detraccion.descripcion }}</option>
                                </select>
                                <br>
                            </template>
                            </b-col>
                        </b-row>
                        </b-col>
                        <b-col cols="2" sm="2"	md="2"	lg="2"	xl="2">
                        <div>
                            {{ moneda.simbolo }}
                        </div>
                        <div>
                            {{ moneda.simbolo }}
                        </div>
                        <div>
                            {{ moneda.simbolo }}
                        </div>
                        <div>
                            {{ moneda.simbolo }}
                        </div>
                        <div>
                            {{ moneda.simbolo }}
                        </div>
                        <div>
                            {{ moneda.simbolo }}
                        </div>
                        <div>
                            {{ moneda.simbolo }}
                        </div>
                        <div>
                            {{ moneda.simbolo }}
                        </div>
                        </b-col>
                        <b-col cols="4" sm="4"	md="4"	lg="4"	xl="4">
                        <div class="alineacionTotales">
                            {{ accumulateIgv() }}
                        </div>
                        <div class="alineacionTotales">
                            {{ accumulateRecordedSale() }}
                        </div>
                        <div class="alineacionTotales">
                            {{ accumulateExoneratedSale() }}
                        </div>
                        <div class="alineacionTotales">
                            {{ accumulateUnaffectedSale() }}
                        </div>
                        <div class="alineacionTotales">
                            {{ accumulateFreeSale() }}
                        </div>
                        <div class="alineacionTotales">
                            {{ accumulateExportSale() }}
                        </div>
                        <div class="alineacionTotales">
                            {{ accumulateOtrosCargos() }}
                        </div>
                        <div class="alineacionTotales">
                            <strong>{{ accumulateTotalSale() }}</strong>
                        </div>
                        </b-col>
                    </b-row>
                    <br>
                    <div class="row">
                        <div class="col-md-6"></div>
                        <div class="col-md-4">
                            <template v-if="validateInvoice()">
                                <button v-if="!cargandoemision" class="btn btn-primary" @click.prevent="sendInvoice"><i class="fa fa-location-arrow"></i> Previsualizar</button>
                                <button v-else class="btn btn-seconday"><i class="fa fa-spin fa-spinner"></i> Previsualizar</button>
                            </template>
                            <template v-else>
                                <button class="btn btn-secondary" disabled><i class="fa fa-send"></i> Previsualizar</button>
                            </template>
                        </div>
                    </div>        
                </div>  
            </div>
        </template>
        <template v-else>
            <vista-pre-emison :documentPrev="invoice" :tipodoc="tipodoc" @preEmision="backEmision"></vista-pre-emison>
        </template>
        <template v-if="postEmision">
            <vista-post-emison @closePreview="closeModal" :idDocumentPreview="idDocumentPreview" :tipoDocPreview="tipoDocPreview"></vista-post-emison>
        </template> 
        <vue-snotify></vue-snotify>
        </b-card>
    </div>
</template>

<script>
import axios from 'axios'
import download from 'downloadjs'
import Datepicker from 'vuejs-datepicker'
import {es} from 'vuejs-datepicker/dist/locale'
import { Datetime } from 'vue-datetime'
import vSelect  from 'vue-select'
import { DocumentosHuesped } from '@/shared/utils'
import { Departamentos } from '@/shared/utils'
import { FormaPago } from '@/shared/utils'
import { TipoMoneda } from '@/shared/utils'
import { codigoPaises } from '@/shared/paises'
import { DocumentosIdentidadExtrangeros } from '@/shared/utils'
import vistaPreEmision from '@/components/comunes/VistaPreEmision'
import vistaPostEmision from '@/components/comunes/VistaPostEmision'
export default {
    name: 'FacturaHospedaje',
    components: {
        Datepicker,
        vSelect,
        datetime: Datetime,
        'vista-pre-emison': vistaPreEmision,
        'vista-post-emison': vistaPostEmision
    },
    data: () => {
        return {
            addedit: true,
            textbutton: 'Agregar',
            sumatoriaOtrosCargos: 0,
            guardandootroscargos: true,
            otroscargosmodal: false,
            otroCargo: {codigo: '50', descripcion: 'Cargos globales que no afectan la base imponible del IGV/IVAP'},
            listaOtrosCargos: [
                {codigo: '50', descripcion: 'Cargos globales que no afectan la base imponible del IGV/IVAP'}
            ],
            listaOtrosCargosAgregados: [],
            otroscargos_fields: [
                {key: 'descripcion', label: 'Descripcion', sortable: true},
                {key: 'montoCargo', label: 'Monto', sortable: true},
                // {key: 'montoBaseCargo', label: 'Base', sortable: true},
                {key: 'acciones', label: 'Acciones'}
            ],
            otroscargosbusy: false,
            montoOtroCargo: '',
            preEmision: true,
            postEmision: false,
            tipoguialock: false,
            closePreview: 0,
            tipoDocPreview: 0,
            idDocumentPreview: 0,
            disableditemsadicionales: false,
            adicionalesalhuesped: false,
            nombresApellidosHuesped: '',
            tipoDocumentoHuesped: 7,
            pasaporte: null,
            residencia: null,
            numeroDiasPermanencia: '',
            numeroDocumentoHuesped: '',
            fechaIngresoPais: '',
            fechaIngresoEstablecimiento: '',
            fechaSalidaEstablecimiento: '',
            fechaConsumo: '',
            placeholderIngresoPais: '',
            placeholderIngresoEstablecimiento: '',
            placeholderSalidaEstablecimiento: '',
            placeholderFechaConsumo: '',
            descripcion: '',
            indexSerie: 0,
            seriesCargadas: true,
            newSerie: true,
            rolSeries: '',
            listaSeries: [],
            tipoDocumentoExtrangeros: '0',
            tipodoc: '1',
            listaPaises: codigoPaises,
            item: {
                unidadMedidaCantidad: 'ZZ',
                cantidad: '',
                descripcion: '',
                valorUnitario: 0,
                precioVentaUnitario: 0,
                codigoProductoSunat: '',
                tipoPrecioVentaUnitario: '',
                montoTotalImpuestosItem: 0,
                baseAfectacionIgv: 0,
                montoAfectacionIgv: 0,
                porcentajeImpuesto: 0,
                tipoAfectacionIgv: '',
                codigoTributo: "9995",
                valorVenta: 0,
                adicional: {
                    beneficioHospedaje: {
                        numeroDocumentoHuesped: '',
                        tipoDocumentoHuesped: '',
                        codigoPaisEmisionPasaporte: '',
                        nombresApellidosHuesped: '',
                        codigoPaisResidenciaHuesped: '',
                        fechaIngresoPais: '',
                        fechaIngresoEstablecimiento: '',
                        fechaSalidaEstablecimiento: '',
                        fechaConsumo: '',
                        numeroDiasPermanencia: 0
                    }
                }
            },
            documentosIdentidad: DocumentosHuesped,
            documentosIdentidadExtrangeros: DocumentosIdentidadExtrangeros,
            cargandoreceptor: false,
            cargandoreceptorViajante: false,
            listarec: true,
            norec: false,
            invoice: {
                tipoOperacion: '',
                serie: '',
                montoTotalImpuestos: 0.00,
                totalVentaExportacion: 0.00,
                sumatoriaIgv: 0.00,
                importeTotal: 0.00,
                adicional: {},
                guiasRelacionada: [],
                items: [],
                receptor: {
                    tipo: '',
                    nro: '',
                    razonSocial: '',
                    direccionFiscal: ''
                }
            },
            moneda: {
                id: '1',
                codigo: 'PEN',
                descripcion: 'SOLES',
                simbolo: 'S/.'
            },
            largeModal: false,
            tipoOperacion: '0202',
            serie: '',
            seriecon: '',
            montoTotalImpuestos: 0.00,
            totalVentaInafecta: 0.00,
            totalVentaExonerada: 0.00,
            totalVentaGravada: 0.00,
            totalVentaGratuita: 0.00,
            sumatoriaIgv: 0.00,
            importeTotal: 0.00,
            baseCargo: 0.00,
            Especificacion: [],
            especificacionIgv: '02',
            adicional: {
                serieGuia: '',
                numeroGuia: '',
                tipoGuia: '',
                fechaVencimiento: '',
                codigoSunatEstablecimiento: 'A000'
            },  
            unidadMedidaCantidad: 'ZZ',
            tipoAfectacionIgv: '01',
            cantidad: '1',
            precioVentaUnitario: '',
            valorUnitario: '',
            flagPrecio: false,
            flagValor: false,
            flagCantidad: false,
            flagDescripcion: false,
            tipoIgv: '01',
            vunitario: false,
            servicio: false,
            ventaGratuita: false,
            descuento: false,
            cargando: false,
            cargandopdf: false,
            cargandopdf2: false,
            cargandocdr: false,
            itemValid: false,
            tipoAfecIgv: false,
            items: [], 
            fields: [
                { key: 'cantidad', label: 'Cantidad', sortable: true },
                { key: 'descripcion', label: 'Descripción', sortable: true, class: 'text-left' },
                {key: 'valorUnitario', label: 'Valor Unitario', sorteable: true},
                {key: 'valorVenta', label: 'Valor Total', sorteable: true},
                { key: 'acciones', label: 'Acciones' }
            ],
            fields_details: [
                { key: 'numeroDocumentoHuesped', label: 'Documento', sortable: true },
                { key: 'nombresApellidosHuesped', label: 'Nombres', sortable: true, class: 'text-left' },
                {key: 'codigoPaisEmisionPasaporteNombre', label: 'Pasaporte O.', sorteable: true},
                {key: 'codigoPaisResidenciaHuespedNombre', label: 'Pais Res.', sorteable: true},
                {key: 'fechaIngresoEstablecimiento', label: 'F. Ingreso H.', sorteable: true},
                {key: 'fechaSalidaEstablecimiento', label: 'F. Salida H.', sorteable: true},
                {key: 'fechaConsumo', label: 'F. Consumo', sorteable: true},
                {key: 'numeroDiasPermanencia', label: 'Dias Permanencia', sorteable: true}
            ],
            huesped: {
                nombresApellidosHuesped: '',
                numeroDocumentoHuesped: '',
                codigoPaisEmisionPasaporte: '',
                codigoPaisResidenciaHuesped: '',
                numeroDiasPermanencia: '',
                fechaIngresoPais: '',
                fechaIngresoEstablecimiento: '',
                fechaSalidaEstablecimiento: '',
                fechaConsumo: ''
            },           
            emisor: {
               ruc: '',
               razonSocial: '',
               serie: '',    
            },
            cliente: {
                ruc: '',
                razonSocial: ''
            },
            ruc: '',
            listaReceptores: [],
            listaViajantes: [],
            es: es,
            adicionales: [],
            nombre: '',
            valor: '',
            total: '',
            editarbtn: true,
            eliminarbtn: false,
            invoices: [],
            invoices_fields: [
                {key: 'serie', label: 'Serie', sorteable: true},
                {key: 'numero', label: 'Numero', sorteable: true},
                {key: 'emision', label: 'Emisión', sorteable: true},
                {key: 'receptor', label: 'Receptor', sorteable: true},
                {key: 'moneda', label: 'Total Gravado', sorteable: true},
                {key: 'estado', label: 'Estado', sorteable: true},
                {key: 'acciones', label: 'Acciones'}
            ],
            pactual: 1,
            limite: 10,
            orden: 'desc',
            total: 0,
            correos: '',
            pdfobject: '',
            recipients: '',
            desde: '',
            hasta: '',
            cargandoemision: false,
            cargandoadicionales: true,
            cargandorelacionadas: true,
            femision: '',
            fvencimiento: '',
            items_guias: [],
            fields_guias: [ 
                {key: 'serie', label: 'Serie', sorteable: true},
                {key: 'numero', label: 'Numero', sorteable: true},
                {key: 'tipodeguiadescripcion', label: 'Tipo', sorteable: true},
                {key: 'acciones', label: 'Acciones', sorteable: true}    
            ],
            items_adicionales: [],
            fields_adicionales: [
                {key: 'clave', label: 'Clave', sorteable: true},
                {key: 'valor', label: 'Valor', sorteable: true},
                {key: 'acciones', label: 'Acciones', sorteable: true},   
            ],
            clave: '',
            valor: '',
            cargandoadicional: false,
            striped: false,
            small: false,
            add_update_item: true,
            info: null,
            formaPago: FormaPago,
            tipoMoneda: TipoMoneda,
            itemTitleSubtotal: 'Valor Unitario',
            itemTitleTotal: 'Valor Total',
            formadepago: '008',
            tipodemoneda: {
                id: '1',
                codigo: 'PEN',
                descripcion: 'SOLES',
                simbolo: 'S/.'
            },
            valorUnitario: '',
            especificacion:{
                codigo: '40',
                descripcion: 'Exportación de Bienes o Servicios',
                codigoTributo: '9995'
            },
            codigoTributo:'',
            tabIndex: 0,
            itemGuia: {
                numero: '',
                tipo: ''
            },
            itemAdicional: {
                clave: '',
                valor: ''
            },
            guiasRelacionada: [],
            tiposGuia: [
                    {
                        codigo: '09',
                        nombre: 'Guia Remision Remitente'
                    },
                    {
                        codigo: '31',
                        nombre: 'Guia Remision Transportista'
                    }
            ],  
            seriedeguia: '',
            numerodeguia: '',
            tipodeguia: '09',
            tipodeguiadescripcion: '',
            selected: 1,
            options: [
                { value: 1, text: 'Factura Comercial' },
                { value: 2, text: 'Factura Contingencia' }
            ],
            ordenCompra: '',
            typeInvoice: 1,
            checkvalorunitario: false,
            codigoProducto: '',
            checkcantidad: false,
            responsecheckcantidad: '',
            checkcodigo: false,
            responsecheckcodigo: '',
            checkdescripcion: false,
            responsecheckdescripcion: '',
            checkserie: false,
            serie_valida: '',
            responsecheckserie: '',
            checkseriecon: false,
            responsecheckseriecon: '',
            checkprecioventaunitario: false,
            util: '',
            numero: '',
            name: '',
            currentdate: '',
            diasnopermitidos: {
                ranges: []
            },
            direcciones: [],
            listaCorreos: [],
            setIndex: -1
        }
    },
    mounted () {
        this.initDates(),
        this.initPlaceFechas(),
        this.getSeries()
    },
    computed: {
        unidades () {
            return this.$store.state.UnidadMedida
        },
        state () {
            let expreg = new RegExp("^[A-Z0-9]{3}$")
            if (this.serie.length == 0){

            } else if (!expreg.test(this.serie)) {
                return false
            } else if(this.serie.length == 3 ){
                return true
            }
        },
        invalidFeedback () {
            let expreg = new RegExp("^[A-Z0-9]{3}$")
            if (this.serie.length == 0) {
                return 'Ingresa una Serie'
            } else {
                return 'Minimo 3 caracteres'
            }
        },
        validFeedback () {
            return this.state === true ? 'Perfecto' : ''
        },
        stateSerieGuia () {
            let expreg = new RegExp("^[A-Z0-9]{4}$")
            let numeros = new RegExp("^[0-9]$")
            let arrayserie = this.seriedeguia.split('')
            if(arrayserie[0] == 'T' || numeros.test(arrayserie[0])){
                if (this.seriedeguia.length == 0){

                } else if (!expreg.test(this.seriedeguia)) {
                    return false
                } else if(this.seriedeguia.length == 4 ){
                    return true
                }
            }else{
                return false
            }  
        },
        invalidFeedbackSerieGuia () {
            let expreg = new RegExp("^[A-Z0-9]{4}$")
            if (this.seriedeguia.length == 0) {
                return 'Ingresa una Serie'
            } else {
                return 'Minimo 4 caracteres'
            }
        },
        validFeedbackSerieGuia () {
            return this.stateSerieGuia === true ? 'Perfecto' : ''
        },
        stateOrdenCompra () {
            let expreg = new RegExp("^[A-Z0-9]{1,20}$")
            if (this.ordenCompra.length == 0){

            } else if (!expreg.test(this.ordenCompra)) {
                return false
            } else if(this.ordenCompra.length < 20 ){
                return true
            }
        },
        invalidFeedbackOrdenCompra () {
            let expreg = new RegExp("^[A-Z0-9]{1,20}$")
            if (this.ordenCompra.length == 0) {
                return 'Ingresa una Orden de Compra'
            } else {
                return 'Caracter Invalido'
            }
        },
        validFeedbackOrdenCompra () {
            return this.stateOrdenCompra === true ? 'OC Valida' : ''
        }
    },
    watch: {
        codigoProducto: function () {
            if(this.codigoProducto.length == 30){
                this.checkcodigo = true
                this.responsecheckcodigo = 'Alfanumerico de 1 a 30 caracteres '
            }else{
                this.checkcodigo = false
                this.responsecheckcodigo = ''
            }
        },
        descripcion: function () {
            if(this.descripcion.length > 500){
                this.checkdescripcion = true
                this.responsecheckdescripcion = 'Alfanumerico de maximo 500 caracteres '
            }else{
                this.checkdescripcion = false
                this.responsecheckdescripcion = ''
            }
        },
        precioVentaUnitario: function () {
            if(this.precioVentaUnitario < 0){
                this.checkprecioventaunitario = true
                this.responsecheckprecioventaunitario = 'Cantidad debe ser mayor a 0'
            }else{
                this.checkprecioventaunitario = false
                this.responsecheckprecioventaunitario = ''
            }
            this.valorUnitario = this.precioVentaUnitario
        },
        valorUnitario: function () {
            if(this.valorUnitario < 0){
                this.checkvalorunitario = true
                this.responsecheckvalorunitario = 'Cantidad debe ser mayor a 0'
            }else{
                this.checkvalorunitario = false
                this.responsecheckvalorunitario = ''
            }
            if(this.vunitario)
            { 
                this.precioVentaUnitario = this.valorUnitario
            }   
        },
        tipodemoneda: function () {
            this.moneda = this.tipodemoneda
        },       
        servicio: function (val) {
            if(this.servicio){
                this.unidadMedidaCantidad = 'ZZ'
            }else{
                this.unidadMedidaCantidad = 'NIU'
            }
        },
        'invoice.receptor.nro': function () {
            if(this.invoice.receptor.nro.length == 0){
                this.invoice.receptor.tipo = ''
                this.invoice.receptor.nro = ''
                this.invoice.receptor.razonSocial = ''
                this.invoice.receptor.direccionFiscal = ''
            }
        },
        'invoice.receptor.razonSocial': function () {
            if(this.invoice.receptor.razonSocial.length == 0){
                this.invoice.receptor.tipo = ''
                this.invoice.receptor.nro = ''
                this.invoice.receptor.razonSocial = ''
                this.invoice.receptor.direccionFiscal = ''
            }
        }
    },
    methods: { 
        editItem: function (value, index) {
            this.textbutton = 'Actualizar',
            this.addedit = false,
            this.setIndex = index,
            this.cantidad = value.cantidad
            this.precioVentaUnitario = value.precioVentaUnitario
            this.descripcion = value.descripcion
            this.tipoDocumentoHuesped = value.adicional.beneficioHospedaje.tipoDocumentoHuesped 
            this.numeroDocumentoHuesped = value.adicional.beneficioHospedaje.numeroDocumentoHuesped
            this.nombresApellidosHuesped = value.adicional.beneficioHospedaje.nombresApellidosHuesped
            this.pasaporte = {codigo: value.adicional.beneficioHospedaje.codigoPaisEmisionPasaporte, nombre: value.adicional.beneficioHospedaje.codigoPaisEmisionPasaporteNombre}
            this.residencia = {codigo: value.adicional.beneficioHospedaje.codigoPaisResidenciaHuesped, nombre: value.adicional.beneficioHospedaje.codigoPaisResidenciaHuespedNombre}
            this.fechaIngresoPais = value.adicional.beneficioHospedaje.fechaIngresoPais
            this.fechaIngresoEstablecimiento = value.adicional.beneficioHospedaje.fechaIngresoEstablecimiento
            this.fechaSalidaEstablecimiento = value.adicional.beneficioHospedaje.fechaSalidaEstablecimiento
            this.fechaConsumo = value.adicional.beneficioHospedaje.fechaConsumo
            this.numeroDiasPermanencia = value.adicional.beneficioHospedaje.numeroDiasPermanencia
        },
        closeReceiver: function () {
            this.listarec = false,
            this.norec = false
        },
        cerrarmodalOtroCargo: function () {
            this.otroscargosmodal = false
        },
        accumulateOtrosCargos: function () {
            let val = 0.00
            this.listaOtrosCargosAgregados.forEach(function(element) {
                val += parseFloat(element.montoCargoDescuento);
            });
            this.sumatoriaOtrosCargos = val
            return this.sumatoriaOtrosCargos.toFixed(2)
        },
        deleteOtroCargo: function (index, value) {
            this.$swal({
                title: 'Eliminar Otro Cargo',
                text: 'Seguro de eliminar el cargo con monto '+value.montoCargoDescuento,
                icon: 'error',
                buttons: true,
                dangerMode: true
            }).then((willDelete) => {
                if(willDelete){
                this.listaOtrosCargosAgregados.splice(index,1)
                }
            })
        },
        addMontoCargo: function () {
            let otrocargo = {
                // codigoMotivoCargo: this.otroCargo.codigo,
                // factorNumericoCargo: parseFloat((this.montoOtroCargo*100)/this.importeTotal),
                // montoCargo: parseFloat(this.montoOtroCargo),
                // montoBaseCargo: this.baseCargo
                indicador: "cargo",
                codigoCargoDescuento: this.otroCargo.codigo,
                factorCargoDescuento: parseFloat(((this.montoOtroCargo)/this.importeTotal).toFixed(5)),
                montoCargoDescuento: parseFloat(Number(this.montoOtroCargo).toFixed(2)),
                baseCargoDescuento: parseFloat(Number(this.baseCargo).toFixed(2))
            }
            if(this.montoOtroCargo > 0){
                this.listaOtrosCargosAgregados.push(otrocargo)
                this.montoOtroCargo = ''
            }else{
                this.$snotify.warning('El monto debe ser mayor a 0','Cuidado')
            }
        },
        validateOtrosCargos: function () {
            if(this.listaOtrosCargosAgregados.length > 0){
                return false
            }else{
                return true
            }
        },
        closeModal: function (value) {
            if(value === 1){
                this.postEmision = true
            }else if(value === 2){
                this.postEmision = false
            }
        },
        backEmision(value) {
            if(value.idDocumento === 0){
                this.cargandoemision = false
                this.preEmision = true
                this.postEmision = false
                this.emitiendo = false
            }else if(value.idDocumento != 0){
                this.idDocumentPreview = value.idDocumento
                this.tipoDocPreview = value.tipoDoc
                this.cargandoemision = true
                this.preEmision = true
                this.postEmision = true
                this.initInvoice()
            }
        },
        checkTabsSeries: function () {
            if(this.tabIndex == 7){
                this.getSeries()
            }
        },
        getSeries: function () {
            this.seriesCargadas = true,
            axios
            .post(process.env.VUE_APP_API_URL + 'usuario/series/'+ this.tipodoc, {
                token: this.$store.getters.userToken
            })
            .then(response => (
                this.listaSeries = response.data.data, 
                this.rolSeries = response.data.rol,
                this.seriesCargadas = false
                ))
            .catch(error => {})
        },
        initPlaceFechas: function () {
            this.placeholderIngresoPais = 'Fecha Ingreso Pais',
            this.placeholderIngresoEstablecimiento = 'Fecha Ingreso Hotel',
            this.placeholderSalidaEstablecimiento = 'Fecha Salida Hotel',
            this.placeholderFechaConsumo = 'Fecha Consumo'
        },
        initDates: function () {
            let r1 = {
                from: this.$moment().subtract(50000,'years'),
                to: this.$moment().subtract(4,'days')
            }
            let r2 = {
                from: this.$moment().add(0,'days'),
                to: this.$moment().add(60000,'years')
            }
            this.diasnopermitidos.ranges.push(r1)
            this.diasnopermitidos.ranges.push(r2)
            this.currentdate = this.$moment().format('YYYY-MM-DD HH:mm:ss')
        },
        validateFields: function () {
            if(
                this.cantidad!='' && 
                this.descripcion!='' && 
                this.precioVentaUnitario!=='' &&
                this.tipoDocumentoHuesped != '' &&
                this.nombresApellidosHuesped != '' &&
                this.numeroDiasPermanencia != '' &&
                this.numeroDocumentoHuesped != '' &&
                this.fechaIngresoPais != '' &&
                this.fechaIngresoEstablecimiento != '' &&
                this.fechaSalidaEstablecimiento != '' &&
                this.fechaConsumo != ''
                )
            {
                return false
            }else{
                return true
            }
        },
        validateFieldsGuia: function () {
            if(this.seriedeguia!='' && this.numerodeguia!='' && this.tipodeguia!==''){
                return true
            }else{
                return false
            }
        },
        validateFieldsAdicionales: function () {
            if(this.clave!='' && this.valor!=''){
                return true
            }else{
                return false
            }
        },
        validateInvoice: function () {
            let tiposerie = ''
            if(this.typeInvoice == 1){
                if(this.indexSerie == 0){
                    this.serie = this.listaSeries[0]
                    tiposerie = this.serie
                }else{
                    this.serie = this.listaSeries[this.indexSerie]
                    tiposerie = this.serie
                }
            }else if(this.typeInvoice == 2){
                tiposerie = this.seriecon
            }
            if(tiposerie!==''  && this.items.length>0 && !this.seriesCargadas){
                return true
            }
            else{
                return false
            }
        },
        accumulateIgv: function () {
            let val = 0.00;
                this.items.forEach(function(element) {
                    val += parseFloat(element.montoAfectacionIgv);
            });
            this.montoTotalImpuestos = val,
            this.sumatoriaIgv = val
            return val.toFixed(2)
        },
        accumulateTaxes: function () {
            var val = 0.00;
                this.items.forEach(function(element) {
                    val += parseFloat(element.montoAfectacionIgv);
            });
            this.sumatoriaIgv = val
        },
        accumulateRecordedSale: function () {
            var val = 0.00;
                this.items.forEach(function(element) {
                    if(element.montoAfectacionIgv !== 0){
                        val += parseFloat(element.valorVenta);
                    }
            });
            this.totalVentaGravada = val
            return val.toFixed(2)
        },
        accumulateExoneratedSale: function () {
            var val = 0.00;
            this.totalVentaExonerada = 0
            return val.toFixed(2)
        },
        accumulateUnaffectedSale: function () {
            var val = 0.00;
                this.items.forEach(function(element) {
                    if(element.tipoAfectacionIgv == '30'){
                        val += parseFloat(element.valorVenta);
                    }
            });
            this.totalVentaInafecta = val
            return val.toFixed(2)
        },
        accumulateExportSale: function () {
            var val = 0.00;
            this.items.forEach(function(element) {
            if(element.tipoAfectacionIgv == '40'){
                val += parseFloat(element.valorVenta);
            }
            });
            this.totalVentaExportacion = val
            return val.toFixed(2)
        },
        accumulateFreeSale: function () {
            var val = 0.00
            this.items.forEach(function(element) {
                if(element.tipoAfectacionIgv == '11' ||
                element.tipoAfectacionIgv == '12' ||
                element.tipoAfectacionIgv == '13' ||
                element.tipoAfectacionIgv == '14' ||
                element.tipoAfectacionIgv == '15' ||
                element.tipoAfectacionIgv == '16' ||
                element.tipoAfectacionIgv == '31' ||
                element.tipoAfectacionIgv == '32' ||
                element.tipoAfectacionIgv == '33' ||
                element.tipoAfectacionIgv == '34' ||
                element.tipoAfectacionIgv == '35' ||
                element.tipoAfectacionIgv == '36' ||
                element.tipoAfectacionIgv == '21'
            ){
                val += parseFloat(element.valorVenta);
            }
            });
            this.totalVentaGratuita = val
            return val.toFixed(2)
        },
        accumulateTotalSale: function () {
            var val = 0.00;
            this.importeTotal = this.montoTotalImpuestos + this.totalVentaGravada + this.totalVentaInafecta + this.totalVentaExportacion + this.sumatoriaOtrosCargos
            this.baseCargo = this.importeTotal - this.sumatoriaOtrosCargos
            return this.importeTotal.toFixed(2)
        },
        setInvoice: function (data) {
            this.invoice = data
        },
        sendMail: function (data) {
            this.previacorreo = true
            this.sendcorreo = true
            axios
            .post(process.env.VUE_APP_API_URL + 'facturas/mail', {
                token: this.$store.getters.userToken,
                id: data.idFactura,
                mail: this.recipients 
            })
            .then(response => (
                this.previacorreo = false,
                this.sendcorreo = false,
                this.$snotify.success(response.data.message, 'Exito')        
                ))
            .catch(error => (
                this.previacorreo = false,
                this.sendcorreo = false,
                this.$snotify.error(error.response.data.response, 'Error')
            ))
        },
        downloadXml: function (data){
            let name = data.serie + '-' + data.numero + '.zip'
            let file = 'data:application/zip;base64,'+ data.xml           
            download(file, name,'application/zip');
        },
        viewPdf: function (data) {
            this.pdfobject = ''
            this.cargandopdf2 = true
            axios
           .post(process.env.VUE_APP_API_URL + 'facturas/pdf',{
               token: this.$store.getters.userToken,
               id: data.idFactura
           })
           .then(response => (
               this.pdfobject = response.data.base64,
               this.cargandopdf2 = false
           ))
           .catch(function (error){
               
           })      
        },
        downloadPdf: function (data){
            let tag = document.createElement('i')
            tag.classList.add('fa','fa-spin', 'fa-spinner')
            let name = data.serie + '-' + data.numero + '.pdf'
            let file = 'data:application/pdf;base64,'+ data.pdf
            this.cargandopdf = true
            this.$swal({
                title: 'Procesando Descarga',
                content: tag,
                icon: 'info',
                buttons: false,
                dangerMode: false
            })
           axios
           .post(process.env.VUE_APP_API_URL + 'facturas/pdf',{
               token: this.$store.getters.userToken,
               id: data.idFactura
           })
           .then(response => (
               file = 'data:application/zip;base64,'+ response.data.base64,
               this.cargandopdf = false,               
               download(file, name,'application/pdf'),
               this.$swal.close()
           ))
           .catch(function (error){
               
           })            
        },
        downloadCdr: function (data){
            let tag = document.createElement('i')
            tag.classList.add('fa','fa-spin', 'fa-spinner')
            let name = 'CDR-' + data.serie + '-' + data.numero + '.zip'
            let file = 'data:application/pdf;base64,'+ data.pdf
            this.cargandocdr = true
            this.$swal({
                title: 'Procesando Descarga',
                content: tag,
                icon: 'info',
                buttons: false,
                dangerMode: false
            })
           axios
           .post(process.env.VUE_APP_API_URL + 'facturas/constancia',{
               token: this.$store.getters.userToken,
               id: data.idFactura
           })
           .then(response => (
               file = 'data:application/zip;base64,'+ response.data.msg.xml,
               this.cargandocdr = false,               
               download(file, name,'application/zip'),
               this.$swal.close()
           ))
           .catch(function (error){
               
           })    
        },
        addItem: function () {
            let item = {
                adicional: {}
            }
            item.baseAfectacionIgv = this.valorUnitario*this.cantidad,
            item.valorVenta = this.valorUnitario*this.cantidad,
            item.tipoAfectacionIgv = this.especificacion.codigo,
            item.montoTotalImpuestosItem = 0, 
            item.codigoTributo = this.especificacion.codigoTributo,
            item.unidadMedidaCantidad = 'ZZ',
            item.idProducto = '-',
            item.cantidad = parseFloat(this.cantidad),
            item.descripcion = this.descripcion,
            item.valorUnitario = parseFloat(this.valorUnitario) 
            item.tipoPrecioVentaUnitario = '01'
            item.montoAfectacionIgv = parseFloat(0.00) 
            item.porcentajeImpuesto = parseInt(0),
            item.precioVentaUnitario = parseFloat(this.precioVentaUnitario), 
            item.valorVenta = parseFloat(this.valorUnitario*this.cantidad)
            this.huesped.tipoDocumentoHuesped = this.tipoDocumentoHuesped,
            this.huesped.nombresApellidosHuesped = this.nombresApellidosHuesped,
            this.huesped.numeroDocumentoHuesped = this.numeroDocumentoHuesped,
            this.huesped.codigoPaisEmisionPasaporte = this.pasaporte.codigo,
            this.huesped.codigoPaisEmisionPasaporteNombre = this.pasaporte.nombre,
            this.huesped.codigoPaisResidenciaHuesped = this.residencia.codigo,
            this.huesped.codigoPaisResidenciaHuespedNombre = this.residencia.nombre,
            this.huesped.numeroDiasPermanencia = this.numeroDiasPermanencia,
            this.huesped.fechaIngresoPais = this.$moment(this.fechaIngresoPais).format('YYYY-MM-DD'),
            this.huesped.fechaIngresoEstablecimiento = this.$moment(this.fechaIngresoEstablecimiento).format('YYYY-MM-DD'),
            this.huesped.fechaSalidaEstablecimiento = this.$moment(this.fechaSalidaEstablecimiento).format('YYYY-MM-DD'),
            this.huesped.fechaConsumo = this.$moment(this.fechaConsumo).format('YYYY-MM-DD')
            item.codigoProductoSunat = '90111503'
            item.adicionales = 1,
            item.adicional.beneficioHospedaje = this.huesped
            if(this.setIndex != -1){
            Object.assign(this.items[this.setIndex], item)
            this.$snotify.warning('Item Actualizado Correctamente', 'Atencion'),
            this.setIndex = -1,
            this.textbutton = 'Agregar',
            this.addedit = true,
            this.initItem()
            }else{
                this.items.push(item),
                this.initItem()
            }
        },   
        initItem: function () {
            this.cantidad = '1',
            this.precioVentaUnitario = '',
            this.huesped = {},
            this.descripcion = '',
            this.nombresApellidosHuesped = '',
            this.numeroDocumentoHuesped = '',
            this.codigoPaisEmisionPasaporte = '',
            this.codigoPaisResidenciaHuesped = '',
            this.numeroDiasPermanencia = '',
            this.fechaIngresoPais = '',
            this.fechaIngresoEstablecimiento = '',
            this.fechaSalidaEstablecimiento = '',
            this.fechaConsumo = '',
            this.placeholderIngresoPais = 'Fecha Ingreso Pais',
            this.placeholderIngresoEstablecimiento = 'Fecha Ingreso Hotel',
            this.placeholderSalidaEstablecimiento = 'Fecha Salida Hotel',
            this.placeholderFechaConsumo = 'Fecha Consumo',
            this.pasaporte = null,
            this.residencia = null
        },
        deleteItem: function (index) {
            this.$swal({
                title: 'Eliminar Item',
                text: 'Seguro de eliminar este item ???',
                icon: 'error',
                buttons: true,
                dangerMode: true
            }).then((willDelete) => {
                if(willDelete){
                    this.items.splice(index,1)
                }else{

                }
            })
        },
        addGuia: function () {
            let guias = {}
            guias.serie = this.seriedeguia,
            guias.numero = this.numerodeguia
            if(this.tipodeguia == '09'){
                guias.tipodeguiadescripcion = 'Guia de Remision Remitente'
            }
            else if(this.tipodeguia == '31'){
                guias.tipodeguiadescripcion = 'Guia de Remision Transportista'
            }
            guias.tipo = this.tipodeguia,
            this.itemGuia.numero = this.seriedeguia + '-' + this.numerodeguia
            this.itemGuia.tipo = this.tipodeguia
            this.items_guias.push(guias)
            this.guiasRelacionada.push(this.itemGuia)
            this.itemGuia = {}
            this.seriedeguia = ''
            this.numerodeguia = ''
            this.tipoguialock = true
        },
        deleteGuia: function (value) {
            this.items_guias.splice(value,1)
            this.guiasRelacionada.splice(value,1)
            this.seriedeguia = ''
            this.numerodeguia = ''
            if(this.items_guias.length==0){
                this.tipoguialock = false
            }
        },  
        addAdicional: function () {
           this.itemAdicional.clave = this.clave
           this.itemAdicional.valor = this.valor
           this.items_adicionales.push(this.itemAdicional) 
           this.itemAdicional = {}
           this.clave = ''
           this.valor = ''
        },
        deleteAdicional: function (value) {
            this.items_adicionales.splice(value,1)
        },  
        backItem: function (item) {
            this.add_update_item = false
            //this.item = item
        },
        updateItem: function (index) {
            this.add_update_item = true,
            this.item = {},
            this.$swal('Updated', 'Cambiando datos', 'warning')
        },
        insertarAdicionales: function (event) {
            let item = {    
                nombre: this.adicionales.nombre,
                valor: this.adicionales.valor     
            }
            this.adicionales.push(item)
            this.adicionales.nombre = '',
            this.adicionales.valor = ''
        },
        listInvoice: function () {
            this.cargando = true
            axios
            .post(process.env.VUE_APP_API_URL + 'facturas', {
                token: this.$store.getters.userToken,
                page: this.pactual,
                limit: this.limite,
                order: this.orden

            })
            .then(response => (
                this.invoices = response.data.data,
                this.total = response.data.total,
                this.desde = response.data.from,
                this.hasta = response.data.to,
                this.cargando = false
                ))
            .catch(error => {
            })
        },
        sendInvoice: function () {
            this.cargandoemision = true
            this.invoice.tipoOperacion = this.tipoOperacion
            this.invoice.token = this.$store.getters.userToken
            this.invoice.receptor.tipo = this.tipoDocumentoExtrangeros
            if(this.typeInvoice == 1){
                if(this.indexSerie == 0){
                    this.invoice.serie = this.listaSeries[0]
                }else{
                    this.invoice.serie = this.listaSeries[this.indexSerie]
                }
            }else{
                this.invoice.serie = this.seriecon
                this.invoice.numero = this.numero
            }
            this.invoice.montoTotalImpuestos = this.montoTotalImpuestos*this.item.cantidad
            this.invoice.sumatoriaIgv = this.sumatoriaIgv
            //this.invoice.totalVentaGravada = this.totalVentaGravada
            this.invoice.totalVentaExportacion = this.totalVentaExportacion
            this.invoice.totalVentaGratuita = this.totalVentaGratuita
            //this.invoice.totalVentaInafecta = this.totalVentaInafecta
            //this.invoice.totalVentaExonerada = this.totalVentaExonerada
            this.invoice.importeTotal = this.importeTotal
            this.invoice.tipoMoneda = this.tipodemoneda.codigo
            if(this.guiasRelacionada !=''){
                 this.invoice.guiasRelacionada = this.guiasRelacionada
            }else{
                delete this.invoice.guiasRelacionada
            }
            if(this.items_adicionales!=''){
                 this.invoice.adicional.extras = this.items_adicionales
            }else{
                 delete this.invoice.adicional.extras
            }
           
            // this.invoice.adicional.formaPago = this.items_adicionales
            this.invoice.adicional.dirAlternativa = this.invoice.receptor.direccionFiscal
            if(this.sumatoriaOtrosCargos > 0){
                // this.invoice.adicional.cargosGlobal = this.listaOtrosCargosAgregados
                this.invoice.cargosDescuentosGlobales = this.listaOtrosCargosAgregados
                this.invoice.sumatoriaOtrosCargos = this.sumatoriaOtrosCargos
            }
            if(this.femision != ''){
                this.invoice.fechaEmision = this.$moment(this.femision).format('YYYY-MM-DD HH:mm:ss')
            }
            if(this.fvencimiento != ''){
                this.invoice.adicional.fechaVencimiento = this.$moment(this.fvencimiento).format('YYYY-MM-DD')
            }
            if(this.formadepago != '000'){
                this.invoice.adicional.formaPago = this.formadepago
            }
            this.invoice.adicional.ordenCompra = this.ordenCompra
            this.invoice.adicional.ordenCompra = this.ordenCompra
            this.invoice.items = this.items
            this.preEmision = false
        },
        initInvoice: function () {
            this.precioVentaUnitario = '',
            this.cargandoemision = false,
            this.tabIndex = 1,
            this.serie = '',
            this.seriecon = '',
            this.tipoDocumento = 0,
            this.formadepago = '000',
            this.ordenCompra = '',
            this.items_guias = [],
            this.guiasRelacionada = [],
            this.seriedeguia = '',
            this.numerodeguia = '',
            this.tipodeguia = '09',
            this.items_adicionales = [],
            this.fvencimiento = '',
            this.clave = '',
            this.valor = '',
            this.typeInvoice = 1,
            this.items = [],
            this.ubigeoPartida = '',
            this.ubigeoLlegada = '',
            this.direccionPartida = '',
            this.direccionLlegada = '',
            this.tipoguialock = false,
            this.invoice = {
                tipoOperacion: '',
                serie: '',
                montoTotalImpuestos: 0.00,
                totalVentaExportacion: 0.00,
                sumatoriaIgv: 0.00,
                importeTotal: 0.00,
                adicional: {},
                guiasRelacionada: [],
                items: [],
                receptor: {
                    tipo: '',
                    nro: '',
                    razonSocial: '',
                    direccionFiscal: ''
                }
            },
            this.sumatoriaOtrosCargos = 0,
            this.listaOtrosCargosAgregados = [],
            this.tipoDocumentoExtrangeros = '0'
        },
        catchError: function (value) {
            let errorgateway = ''
            let errormessage = ''
            let errordescription = ''
            value.msg ? errorgateway = value.msg: errorgateway = ''
            value.response.message ? errormessage = value.response.message: errormessage = ''
            value.response.description ? errordescription = value.response.message: errordescription = ''
            this.$snotify.error(errordescription + ' - ' + errormessage + ' - ' + errorgateway, 'Error')
        },
        setReceiver: function (item) {
            this.invoice.receptor.nro = item.idReceptor,
            this.invoice.receptor.tipo = item.tipo,
            this.invoice.receptor.razonSocial = item.razonSocial,
            this.invoice.receptor.direccionFiscal = item.direccionReferencia,
            this.direcciones = item.direcciones,
            this.listaCorreos = item.email,
            this.listarec = false,
            this.listaReceptores = [],
            this.tipoDocumentoExtrangeros = item.tipo
        },
        getReceivers: function (value) {
            this.listaReceptores = []
            let link = ''
            let cadenabusqueda = ''
            if(value === 1){
                link = 'receptores/listaconterceros',
                cadenabusqueda = this.invoice.receptor.nro
            }else if(value === 2){  
                link = 'receptores/listaconterceros/razonsocial'
                cadenabusqueda = this.invoice.receptor.razonSocial
            }
            this.cargandoreceptor = true
            this.listarec = true
            this.norec = false
            axios
            .post(process.env.VUE_APP_API_URL + link,{
                token: this.$store.getters.userToken,
                q: cadenabusqueda,
                tipoRec: this.tipoDocumentoExtrangeros
            })
            .then(response => (
                this.filtroReceiver(response.data),
                this.cargandoreceptor = false,
                this.receivercount(this.listaReceptores.length)                             
            ))
            .catch(error => (
                this.cargandoreceptor = false
            ))              
        },
        filtroReceiver: function (value) {
            if(value.length > 0){
                this.tiporeceivers = false,
                this.listaReceptores = value
            }else{
                this.$snotify.warning('No se encontraron receptores','Atención'),
                this.tiporeceivers = false,
                this.listaReceptores = [],
                this.listarec = false
                this.norec = false
            }
        },
        getReceiversViajante: function (value) {
           if(value.length>3){
               this.cargandoreceptorViajante = true
               this.listarecViajante = true
               this.norecViajante = false
               axios
                .post(process.env.VUE_APP_API_URL + 'receptores/lista',{
                    token: this.$store.getters.userToken,
                    q: value,
                    tipoRec: this.tipoDocumentoPasajero
                })
                .then(response => (
                    this.listaViajantes = response.data,
                    this.cargandoreceptorViajante = false,
                    this.receivercountViajante(this.listaViajantes.length)
                ))
                .catch(error => {
                    this.cargandoreceptorViajante = false
                })
            }            
        },
        receivercount: function (value){
            if(!value)
            {
                this.norec = true
            }
            else
            {
                this.norec = false
            }
        },
        receivercountViajante: function (value){
            if(!value)
            {
                this.norec = true
            }
            else
            {
                this.norec = false
            }
        },
        customFormatter(date) {
            return this.$moment(date).format('YYYY-MM-DD HH:mm:ss');
        },
        changeTab: function (value){
            this.$emit("tabindex", value);
        }
    }
}
</script>

<style scoped>
  .facturador{
      padding-left: 20px;
      padding-right: 20px;
  }
  .botones{
      margin-top: 30px;
  }
  #info_item{
      margin-right: 15px;
  }
  .inputpersonalizado{
    width: 100%;
    border: none;
    border-bottom: 1px solid #ccc;
  }
  .dropdown li {
  border-bottom: 1px solid rgba(112, 128, 144, 0.1)
}

.dropdown li:last-child {
  border-bottom: none;
}

.dropdown li a {
  padding: 10px 20px;
  display: flex;
  width: 100%;
  align-items: center;
  font-size: 1.25em;
}

.dropdown li a .fa {
  padding-right: 0.5em;
}
.dropdown-toggle{
    padding-bottom: 0px !important;
}
.v-select .dropdown-toggle .clear {
    font-size: 23px;
    font-weight: 700;
    line-height: 1;
    color: rgba(60,60,60,.5);
    padding: 0;
    border: 0;
    background-color: transparent;
    cursor: pointer;
    margin-right: 6px;
    display: none;
}
label
{
    margin-bottom: 0 !important;
}
.input-requerido::placeholder {
    color:red;
    opacity: 0.7;
}
.searcher-field{
    z-index: 1000;
    position: absolute;
    max-height: 400px !important;
    overflow-y: scroll;
    width: 500px !important;
    border: none !important;
}
.searcher-result{
    font-size: smaller;
    padding: 2px 0px 2px 0px;
    cursor: pointer;
}
.sinresultados{
    padding: 0 5px 0 5px;  
}
.theme-orange .vdatetime-popup__header,
.theme-orange .vdatetime-calendar__month__day--selected > span > span,
.theme-orange .vdatetime-calendar__month__day--selected:hover > span > span {
  background: #FF9800;
}

.theme-orange .vdatetime-year-picker__item--selected,
.theme-orange .vdatetime-time-picker__item--selected,
.theme-orange .vdatetime-popup__actions__button {
  color: #ff9800;
}
.colorestelemovil{
    background-color: #006eae;
    color: #ffffff;
}
.input-placedark::placeholder {
  color:#353333;
  opacity: 0.9;
}
</style>

